import { buildCommonFilters, embedFilter } from '../sharedFilters'

const DATASET_KEY = 'trainings'

const commonFilters = buildCommonFilters(DATASET_KEY, {
  INSTALLATION: { label: 'REMS' },
  MUNICIPALITY: {},
  STATUS: { column: 'training_status.name', label: 'Estatus' },
  REGION: { column: 'regions.name', label: 'Estado' },
  SECTOR: { column: 'sectors.name', label: 'Región' },
  CENTER: false,
  TENANT: false,
  USER: { label: 'Usuario (validador)' },
})

export default {
  key: DATASET_KEY,
  label: 'Capacitaciones',
  timeColumn: 'trainings.created_at',
  permission: { action: 'read', subject: 'Trainings' },

  tables: {
    trainings: ["id", "id_center", "id_sector", "id_region", "reference_number", "registration_date", "training_type", "training_topic", "training_modality", "description_training", "files", "created_at", "updated_at"],
    training_validations: ["id", "id_training", "id_status", "id_user", "id_user_validation", "comments", "approved_at", "rejected_at", "reopened_at", "canceled_at", "created_at", "updated_at"],
    training_units: ["id", "id_training", "id_unit", "participants", "created_at", "updated_at"],
    training_status: ["id", "name", "created_at", "updated_at"],
    users: ["id", "id_unit", "id_maintenance_company", "image", "check_alarms", "frame_color", "id_profile", "user", "email", "password", "name", "first_name", "second_name", "config", "plate_number", "created", "updated", "active", "vpn_access", "allow_virtual_button_alarm", "allow_visual_notifications", "allowed_units_live_video_flows", "phone_number", "alarm_history_per_hours", "alarm_history_per_days", "alarm_history_by_records", "last_login", "video_wall", "active_sesion_video_wall", "id_country", "auth_two_factor_code", "auth_two_factor_time", "auth_two_factor_type", "verify_email_code", "verify_sms_code", "verify_sms", "verify_email", "online", "enabled_chat", "enabled_helpdesk"],
    units: ["id", "id_router", "description", "address_1", "address_2", "exterior_number", "suburb", "number", "postal_code", "id_country", "id_region", "id_sector", "active", "route", "plate_number", "vin", "driver", "provider", "owner", "company", "vehicle", "allow_virtual_button_alarm", "reaction_patrol", "id_alarms_levels", "active_digital_output", "needs_check", "id_municipality", "time_zone", "data", "comments", "id_category", "id_seproban", "rems", "sirh", "created_at", "updated_at"],
    sectors: ["id", "id_center", "name", "alcaldia", "provider", "created", "updated"],
    regions: ["id", "name", "code", "country_id", "acronym", "created_at", "updated_at"],
    centers: ["id", "tenant_id", "name", "description", "updated", "created", "active"],
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  defaults: {
    field: 'units.description',
    // field2: 'training_status.name',
  },

  csvConfig: {
    withTables: 'trainings',
    columns: 'trainings.reference_number,trainings.registration_date,trainings.training_type,trainings.training_topic,trainings.training_modality,trainings.description_training,trainings.files,trainings.created_at,trainings.updated_at,training_validations.comments,training_validations.approved_at,training_validations.rejected_at,training_validations.reopened_at,training_validations.canceled_at,training_validations.created_at,training_validations.updated_at,units.description,training_units.participants,training_units.created_at,training_units.updated_at,training_status.name,training_status.created_at,training_status.updated_at,users.user,users.name,users.email,units.description,units.active,centers.name,municipalities.name,sectors.name,regions.name',
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
  },

  fields: [
    { key: 'units.description', label: 'REMS' },
    { key: 'regions.name', label: 'Estado' },
    { key: 'centers.name', label: 'Centro' },
    { key: 'sectors.name', label: 'Región' },
    { key: 'municipalities.name', label: 'Municipio' },
    { key: 'centers.name', label: 'Centro' },
    { key: 'users.name', label: 'Nombre' },
    { key: 'users.id_profile', label: 'Perfil' },
    { key: 'trainings.reference_number', label: 'Referencia' },
    { key: 'trainings.training_type', label: 'Tipo de capacitación' },
    { key: 'trainings.training_topic', label: 'Tema de capacitación' },
    { key: 'trainings.training_modality', label: 'Modalidad' },
    { key: 'trainings.registration_date', label: 'Fecha registro', defaultParams: { freq: '1mo' } },
    { key: 'trainings.created_at', label: 'Fecha de creación', defaultParams: { freq: '1mo' } },
    { key: 'trainings.updated_at', label: 'Fecha de actualización', defaultParams: { freq: '1mo' } },
    { key: 'training_units.participants', label: 'Número de Participantes' },
    { key: 'training_status.name', label: 'Estatus' },
    { key: 'training_status.created_at', label: 'Fecha de creación (Estatus)', defaultParams: { freq: '1mo' } },
    { key: 'training_status.updated_at', label: 'Fecha de actualización (Estatus)', defaultParams: { freq: '1mo' } },
  ],

  filters: [
    ...commonFilters,
    embedFilter(DATASET_KEY, 'trainings.training_type', 'Tipo de capacitación', 'type'),
    embedFilter(DATASET_KEY, 'trainings.training_topic', 'Tema de capacitación', 'topic'),
    embedFilter(DATASET_KEY, 'trainings.training_modality', 'Modalidad', 'modality'),
    embedFilter(DATASET_KEY, 'trainings.description_training', 'Descripción', 'description'),
    embedFilter(DATASET_KEY, 'training_validations.comments', 'Comentarios (Validación)', 'validation_comments'),
    {
      key: 'time',
      label: 'Fecha registro',
      filterType: 'where-date',
      whereColumn: 'trainings.registration_date',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'trainings_updated_at',
      label: 'Fecha de actualización',
      filterType: 'where-date',
      whereColumn: 'trainings.updated_at',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'approved_at',
      label: 'Fecha de aprobación',
      filterType: 'where-date',
      whereColumn: 'training_validations.approved_at',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'rejected_at',
      label: 'Fecha de rechazo',
      filterType: 'where-date',
      whereColumn: 'training_validations.rejected_at',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'reopened_at',
      label: 'Fecha de reapertura',
      filterType: 'where-date',
      whereColumn: 'training_validations.reopened_at',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'canceled_at',
      label: 'Fecha de cancelación',
      filterType: 'where-date',
      whereColumn: 'training_validations.canceled_at',
      optionsConfig: { type: 'date' },
    },
  ],

  dateGrouping: {
    column: 'trainings.registration_date',
    presets: [
      { value: '1d', label: 'Día' },
      { value: '1W', label: 'Semana' },
      { value: '1M', label: 'Mes' },
      { value: '1Y', label: 'Año' },
    ],
  },
}
